"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingFailedWidget = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var ViewerPaneStyles_1 = require("./ViewerPaneStyles");
var LoadingFailedWidget = /** @class */ (function (_super) {
    __extends(LoadingFailedWidget, _super);
    function LoadingFailedWidget() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoadingFailedWidget.prototype.headlineForErrorCode = function (errorCode) {
        var genericError = Localize_1.Messages.Error();
        if (errorCode === null) {
            return genericError;
        }
        switch (errorCode) {
            case 'BACKFILL_RUNNING':
                return Localize_1.Messages.DataDetailsBackfillRunningHeadline();
            case 'RATE_EXCEEDED':
                return Localize_1.Messages.DataDetailsRateExceededHeadline();
            case 'TIME_LIMIT_EXCEEDED':
                return Localize_1.Messages.DataDetailsTimeLimitExceededHeadline();
            case 'NODE_LIMIT_EXCEEDED':
                return Localize_1.Messages.DataDetailsNodeLimitExceededHeadline();
            case 'INGESTION_FAILED':
            case 'INTERNAL_SERVER_ERROR':
            case 'FEATURE_DISABLED':
            default:
                return genericError;
        }
    };
    LoadingFailedWidget.prototype.detailsForErrorCode = function (errorCode) {
        var genericError = Localize_1.Messages.DataDetailsGenericErrorDetails();
        if (errorCode === null) {
            return genericError;
        }
        switch (errorCode) {
            case 'BACKFILL_RUNNING':
                return Localize_1.Messages.DataDetailsBackfillRunningDetails();
            case 'INGESTION_FAILED':
                return Localize_1.Messages.DataDetailsIngestionFailedDetails();
            case 'RATE_EXCEEDED':
                return Localize_1.Messages.DataDetailsRateExceededDetails();
            case 'TIME_LIMIT_EXCEEDED':
                return Localize_1.Messages.DataDetailsTimeLimitExceededDetails();
            case 'NODE_LIMIT_EXCEEDED':
                return Localize_1.Messages.DataDetailsNodeLimitExceededDetails();
            case 'INTERNAL_SERVER_ERROR':
                return Localize_1.Messages.DataDetailsInternalServerErrorDetails();
            case 'FEATURE_DISABLED':
                return Localize_1.Messages.ErrorFeatureDisabled();
            default:
                return genericError;
        }
    };
    LoadingFailedWidget.prototype.render = function () {
        return (React.createElement("div", { className: ViewerPaneStyles_1.lineagePanelBodyWithError },
            React.createElement(data_catalog_shared_1.CenteredMessage, { message: this.headlineForErrorCode(this.props.errorCode) }),
            React.createElement(ViewerPaneStyles_1.LoadingErrorMessage, null, this.detailsForErrorCode(this.props.errorCode)),
            React.createElement(ViewerPaneStyles_1.LoadingErrorCode, null, this.props.errorCode),
            this.props.onRetryRequested
                ? React.createElement(widgets_1.ButtonWidget, { buttonType: widgets_1.ButtonType.Outline, testId: 'retry-load-button', handleClick: this.props.onRetryRequested }, Localize_1.Messages.LoadingFailedButtonText())
                : null));
    };
    return LoadingFailedWidget;
}(React.Component));
exports.LoadingFailedWidget = LoadingFailedWidget;
//# sourceMappingURL=LoadingFailedWidget.js.map